import React from "react";

const TermsAndConditionsPharmacy = ({
  registerForm,
  handleChangeCheckBox,
  getBrochure,
}) => {
  return (
    <React.Fragment>
      <div className="prescriber-confirmation">
        <label htmlFor="confirmation_terms" className="custom-checkbox">
          1. I have read and understood the{" "}
          <span
            className="brochure-link"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              getBrochure();
            }}
          >
            Lenalidomide Healthcare Professional Brochure.
          </span>
          <input
            type="checkbox"
            id="confirmation_terms"
            name="confirmation_terms"
            checked={registerForm.confirmation_terms || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>
        <label
          htmlFor="confirmation_reqs_compliance"
          className="custom-checkbox"
        >
          2. All pharmacists who dispense Lenalidomide will have read and
          understood the Healthcare Professional Brochure and will ensure that
          the pregnancy prevention measures have been implemented before
          dispensing Lenalidomide.
          <input
            type="checkbox"
            id="confirmation_reqs_compliance"
            name="confirmation_reqs_compliance"
            checked={registerForm.confirmation_reqs_compliance || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label htmlFor="confirmation_auth" className="custom-checkbox">
          3. Prescriptions for Lenalidomide will be dispensed only if
          accompanied by a Prescription Authorisation Form (PAF).
          <input
            type="checkbox"
            id="confirmation_auth"
            name="confirmation_auth"
            checked={registerForm.confirmation_auth || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label htmlFor="confirmation_supervised" className="custom-checkbox">
          4. The dispensing pharmacist will check the PAF for completeness
          and/or request any missing information from the prescriber or patient
          and complete the dispensing pharmacist section of the PAF, prior to
          dispensing Lenalidomide.
          <input
            type="checkbox"
            id="confirmation_supervised"
            name="confirmation_supervised"
            checked={registerForm.confirmation_supervised || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label
          htmlFor="confirmation_aged_verification"
          className="custom-checkbox"
        >
          5. For a woman of childbearing potential (WCBP), the dispensing
          pharmacist will check that the PAF confirms:
          <ul>
            <li>
              the WCBP has been counselled/reminded about teratogenic risk and
              has been on at least one effective method of contraception for at
              least 4 weeks
            </li>
            <li>
              the WCBP has had a negative pregnancy test within the 3 days prior
              to the prescription date
            </li>
            <li>
              the dispensing of Lenalidomide is within 7 days of the
              prescription date
            </li>
            <li>the supply of treatment is no more than 4 weeks.</li>
          </ul>
          <input
            type="checkbox"
            id="confirmation_aged_verification"
            name="confirmation_aged_verification"
            checked={registerForm.confirmation_aged_verification || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label htmlFor="confirmation_other" className="custom-checkbox">
          6. For male patients, the dispensing pharmacist will check that the
          PAF confirms:
          <ul>
            <li>
              the patient has been counselled/reminded about teratogenic risk
              and the requirement to use a condom if sexually active with a
              pregnant woman or a woman of childbearing potential not using
              effective contraception.
            </li>
            <li>the supply of treatment is no more than 12 weeks</li>
          </ul>
          <input
            type="checkbox"
            id="confirmation_other"
            name="confirmation_other"
            checked={registerForm.confirmation_other || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label htmlFor="confirmation_other1" className="custom-checkbox">
          7. For women not of childbearing potential the dispensing pharmacist
          will check the supply of treatment is no more than 12 weeks
          <input
            type="checkbox"
            id="confirmation_other1"
            name="confirmation_other1"
            checked={registerForm.confirmation_other1 || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label htmlFor="confirmation_other2" className="custom-checkbox">
          8. If supplied with Lenalidomide, it will only be dispensed to the
          patient by the pharmacy registered with Pharmacare, to fulfil the
          requirements of the PPP for Lenalidomide. Wholesaling is strictly
          prohibited.
          <input
            type="checkbox"
            id="confirmation_other2"
            name="confirmation_other2"
            checked={registerForm.confirmation_other2 || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>

        <label htmlFor="confirmation_other3" className="custom-checkbox">
          9. Notify Pharmacare immediately of changes in Chief Pharmacist or
          appointed Deputy Pharmacist, including their corresponding contact
          details in order to ensure appropriate registration of the pharmacy to
          order and dispense Lenalidomide.
          <input
            type="checkbox"
            id="confirmation_other3"
            name="confirmation_other3"
            checked={registerForm.confirmation_other3 || false}
            onChange={handleChangeCheckBox}
          />
          <span className="checkmark" />
        </label>
      </div>
      <div className="confirm">
        By clicking register, I understand that if during the period of
        registration I am unable to fulfil requirements 1 - 9, the above
        named-pharmacy will be de-registered by Pharmacare and I will be unable
        to order any further Lenalidomide and required to go through the
        registration process again, following any necessary remedial action(s).
        I acknowledge this registration to order and dispense Lenalidomide is
        valid for 2 years only, after which I am required to re-register the
        above-named pharmacy should I wish to continue to order and dispense
        Lenalidomide. I understand that my personal data will be processed by
        Pharmacare, for the purpose of administering the PPP for Lenalidomide
        and that the information supplied to Pharmacare on PAFs will be used to
        provide anonymised aggregate annual reports to the Medicines and
        Healthcare products Regulatory Agency (MHRA) to assess the
        implementation of the PPP.
      </div>
    </React.Fragment>
  );
};
export default TermsAndConditionsPharmacy;
